var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holidayguru"},[_c('div',{attrs:{"id":"holidayguru-trustpilot-buttons-widget-container"}},[_c('HgTrustpilotButtons',{attrs:{"lang":_vm.lang}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }